// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"eeece46d","239":"fa83e3c9","455":"76c6e6b8","488":"887047e1","977":"8113c5c7"}[chunkId] + ".chunk.js";
};